// @flow

import React, { type Element } from 'react'
import { TextField, Box } from '@material-ui/core'
import type { Diagnosis } from '../../types'
import { Autocomplete } from '@material-ui/lab'
import { createFilterOptions } from '@material-ui/lab/Autocomplete'
import DiagnosisOption from './option'

type Props = {|
  diagnoses: Array<Diagnosis>,
  setDiagnoses: (Array<Diagnosis>) => void,
  diagnosesList: Array<Diagnosis>,
  error: string,
|}

function DefaultDiagnosesSelect({
  diagnoses,
  setDiagnoses,
  diagnosesList,
  error,
}: Props): Element<typeof React.Fragment> {
  const handleDiagnosesChange = (
    _event: SyntheticInputEvent<HTMLInputElement>,
    value: Array<Diagnosis>,
    _reason: string
  ): void => {
    setDiagnoses(value)
  }

  const filterOptions = createFilterOptions({
    limit: 5,
    stringify: (option) => option.code + ' ' + option.title,
  })

  return (
    <Box py={2}>
      <Autocomplete
        id="default-diagnoses-select"
        multiple
        fullWidth
        options={diagnosesList}
        filterOptions={filterOptions}
        filterSelectedOptions={true}
        getOptionSelected={(option, value) => option.id === value.id}
        getOptionLabel={(option) => option.code}
        value={diagnoses}
        onChange={handleDiagnosesChange}
        data-testid="diagnoses-autocomplete"
        renderInput={(params) => (
          <TextField
            {...params}
            label="Default Diagnoses"
            variant="outlined"
            error={error !== ''}
            helperText={error ? 'Diagnoses ' + error : error}
          />
        )}
        renderOption={(option) => <DiagnosisOption option={option} />}
      />
    </Box>
  )
}

export default DefaultDiagnosesSelect
